module.exports = __webpack_public_path__ + "static/media/user.e56ae8d9.png";